export const ORDER = {
    ORDER_NUMBER: "orderNumber"
}

export const ACTION = {
    ADD: "add",
    VIEW: "view",
    EDIT: "edit",
    DELETE: "delete",
    NEXT: "next",
    PLACE: "place",
    DECLINE: "decline",
    RECEIVE: "receive",
    CANCEL: "cancel",
    LINK: "link",
    UNLINK: "unlink"
}

export const SHIPMENT = {
    REJECT_SHIPMENT: "rejectShipment",
    CANCEL_SHIPMENT: "cancelShipment"
}